import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Services from './pages/Services';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import { Toaster } from './components/ui/toaster';
import { I18nProvider } from './i18n/I18nContext';

function App() {
  return (
    <div className="App grain">
      <I18nProvider>
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
          </Routes>
          <Footer />
          <Toaster />
        </BrowserRouter>
      </I18nProvider>
    </div>
  );
}

export default App;
